import { Box, Typography, TextField } from "@mui/material";

export default function FeedbackSection({ 
  strengths, 
  setStrengths, 
  areasOfImprovement, 
  setAreasOfImprovement
}) {
  return (
    <Box mb={4}>
      <Typography variant="h5" color="primary" gutterBottom>
        Feedback Personal
      </Typography>

      <Box mb={3}>
        <Typography variant="subtitle1" gutterBottom>
          Fortalezas
        </Typography>
        <TextField
          multiline
          fullWidth
          minRows={6}
          value={strengths}
          onChange={(e) => setStrengths(e.target.value)}
          placeholder="Describe tus principales fortalezas y logros durante este período"
        />
      </Box>

      <Box>
        <Typography variant="subtitle1" gutterBottom>
          Áreas de Mejora
        </Typography>
        <TextField
          multiline
          fullWidth
          minRows={6}
          value={areasOfImprovement}
          onChange={(e) => setAreasOfImprovement(e.target.value)}
          placeholder="Describe las áreas en las que crees que podrías mejorar"
        />
      </Box>
    </Box>
  );
} 